import { Stack } from "expo-router";
import Head from "expo-router/head";
import { ApplyProvider } from "@/contexts/ApplyContext";

export default function ApplyLayout() {
  return (
    <ApplyProvider>
      <Head>
        <title>RockForce Apply</title>
        <meta name="description" content="Apply to work with RockForce" />
      </Head>
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen name="welcome-back" />
        <Stack.Screen name="(wizard)" />
      </Stack>
    </ApplyProvider>
  );
}
